<template>
  <footer class="footer">
    <p class="text-muted mb-1">
      &copy; 2018-2020
      <a href="https://www.superchargify.com/" target="_blank" rel="noopener" class="font-weight-normal text-muted no-deco">Superchargify</a>
    </p>
    <p class="text-muted mb-1">
      <a href="https://medium.com/superchargify" target="_blank" rel="noopener" class="font-weight-normal text-muted no-deco">Blog</a>
      &bull;
      <a href="https://www.superchargify.com/terms/" class="font-weight-normal text-muted no-deco" rel="noopener" target="_blank">Terms of Service</a>
      &bull;
      <a href="https://www.superchargify.com/privacy/" class="font-weight-normal text-muted no-deco" rel="noopener" target="_blank">Privacy</a>
      &bull;
      <a href="https://status.superchargify.com/" target="_blank" rel="noopener" class="font-weight-normal text-muted no-deco">Status</a>
    </p>
    <p class="text-muted small mb-0">2.0.{{commitHash}}</p>
  </footer>
</template>

<script>
export default {
  computed: {
    commitHash: function () {
      if (process.env.VUE_APP_COMMIT_REF) {
        return process.env.VUE_APP_COMMIT_REF.substring(0, 8)
      }

      return 'devenv'
    }
  }
}
</script>
